export var ResponseStatus;
(function (ResponseStatus) {
    ResponseStatus["Confirmed"] = "confirmed";
    ResponseStatus["Rejected"] = "rejected";
    ResponseStatus["Unknown"] = "unknown";
    ResponseStatus["Waiting"] = "waiting";
})(ResponseStatus || (ResponseStatus = {}));
//# sourceMappingURL=types.js.map